var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}

/*
* A function that given a set of arguments, will return all
* sdmx request header options.
* 
* The function will return the url, headers and params options
* 
* @memberOf SDMXJS
* @api public
* @tag parsing
* @param {Object}
* @return {Object}
*
* @example
* const args = {
*   datasource: {
*     hasRangeHeader: true,
*   },
*   format: undefined, // default is 'json'
*   asFile: false,
*   labels: undefined, // default 'code', ignored if not 'csv' format
*   locale: 'en',
*   range: 500,
*   type: 'data', // or artefact type for structure request, i.e. 'dataflow'
* };
*
* SDMXJS.getRequestHeaders(args);
* //=> {
* //=>   Accept: 'application/vnd.sdmx.data+json;version=1.0.0-wd',
* //=>   Accept-Language: 'en',
* //=>   x-range: 'values=0-499'
* //=> }
*/
import * as R from 'ramda';
import { getSdmxFormat } from './getSdmxFormat';
import { getRangeHeader } from './getRangeHeader';
var getRequestHeaders = function getRequestHeaders(_ref) {
  var datasource = _ref.datasource,
    type = _ref.type,
    locale = _ref.locale,
    range = _ref.range,
    rest = _objectWithoutProperties(_ref, ['datasource', 'type', 'locale', 'range']);
  return R.pipe(R.assoc('Accept', getSdmxFormat(_extends({
    datasource: datasource,
    type: type
  }, rest))), function (headers) {
    var h = getRangeHeader({
      type: type,
      datasource: datasource,
      range: range
    });
    return R.isEmpty(h) ? headers : R.assoc('x-range', R.prop('x-range', h), headers);
  })({
    'Accept-Language': locale
  });
};
export { getRequestHeaders };